require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-672-a-3-b-6-c-8153-f-13-dbde-6-d-32-b.json") })
        }
      }, "path---blog-672-a-3-b-6-c-8153-f-13-dbde-6-d-32-b");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-672-a-3-b-6-c-8153-f-13-dbde-6-d-32-b!./.cache/json/blog-672-a-3-b-6-c-8153-f-13-dbde-6-d-32-b.json
// module id = 380
// module chunks = 231608221292675